import React from 'react';
import './SkeletonReel.css';

const shimmerPlaceholders = [0, 1, 2];

function SkeletonReel() {
  return (
    <article
      className="skeletonReel"
      data-testid="skeleton-reel"
      role="presentation"
      aria-hidden="true"
    >
      <div className="skeletonReel__media" />
      <div className="skeletonReel__footer">
        <div className="skeletonReel__title" />
        <div className="skeletonReel__metaRow">
          {shimmerPlaceholders.map((key) => (
            <span key={key} className="skeletonReel__metaChip" />
          ))}
        </div>
      </div>
    </article>
  );
}

export default SkeletonReel;
